import * as React from 'react';

import {
  AtlassianNavigation,
  PrimaryButton,
  PrimaryDropdownButton,
  ProductHome,
} from '@atlaskit/atlassian-navigation';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';

const AtlassianProductHome = () => (
  <ProductHome icon={AtlassianIcon} logo={AtlassianLogo} />
);

export const Navigation = (): JSX.Element => (
  <AtlassianNavigation
    label="site"
    primaryItems={[
      <PrimaryButton key="BifrostBtn">Bifrost</PrimaryButton>,
      <PrimaryDropdownButton key="CookiesBtn">Cookies</PrimaryDropdownButton>,
      <PrimaryDropdownButton key="UIBtn2">UI</PrimaryDropdownButton>,
      <PrimaryButton key="RepositoriesBtn">Repositories</PrimaryButton>,
      <PrimaryButton key="SsrBtn" href="/ssr">
        SSR Baked Cakes
      </PrimaryButton>,
    ]}
    renderProductHome={AtlassianProductHome}
  />
);
